var objTicketSettings = {
    // <summary>
    // This object builds the html in ticket.js
    // </summary>

    _buildHtml: function (me) {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        try {


            //init the main html parts
            me.myHtml = {
                header: {}, topMenu: {}, subMenu: {}, rowPrintInfo: {}, rowAccounting: {}, rowMain: {}, rowUser: {}, rowWatchlist: {}, rowExtWatchlist: {}, rowActivities: {}, rowEmailHistory: {}, rowProjectInfo: {}, footer: {}
            };

            this._buildHeader(me);

            this._buildTopMenu(me);


            this._buildAccountingRow(me);

            this._buildPrintInfoRow(me);

            this._buildUserRow(me);

            this._buildMainRow(me);

            this._buildWatchlistRow(me, me.myHtml.rowWatchlist, "", "int. " +  me.specific.resources.observer);

            this._buildWatchlistRow(me, me.myHtml.rowExtWatchlist, "ext-", "ext. " + me.specific.resources.observer);

            this._buildActivitiesRow(me);

            this._buildEmailHistoryRow(me);

            this._buildProjectInfoRow(me);

            this._buildFooter(me);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _simplify: function (me) {
        /// <summary>
        /// This function simplifies the view of the ticket
        /// </summary>
        try {

            //CURRENTLY ONLY FOR NEW TICKETS
            me.divEntry.addClass("simple");
         
          

            if (me.specific.ticketId == -1) {
                me.myHtml.topMenu.subMenu.hide();
                me.myHtml.rowUser.wrapper.hide();
                me.myHtml.rowMain.infoBox.divScope.hide();
                me.myHtml.rowMain.infoBox.divState.hide();
            }

        } catch (e) { me._writeErr(e);  }
    },


    _buildHeader: function (me) {
        /// <summary>
        /// This function builds the header html structure
        /// ONLY FOR PRINTING
        /// </summary>
        try {
            let obj = me.myHtml.header;
            obj.wrapper = me._setObj("div-header", "").css("width", "100%").css("display", "none");

            //for printing version we add a language dropdown for changing the language
            if (me.specific.print) {
                obj.logo = me._setObj("", "float vc-grid-margin-right").html("<img src='../../" + me.specific.becLogo + "' width='35px'/>");
                obj.header = me._setObj("", "vc-list-header-simple");
                obj.title = me._setObj("", "float").html(me.specific.becName);
              
                //obj.ddlLang = me._setObj("", "").css("float", "right");
                obj.ddlLang = $("<select>").css("float", "right").attr("id", "ddl-lang");
                $.each(JSON.parse(me.specific.languages), function () {
                    obj.ddlLang.append($("<option>").val(this.ID).text(this.ShortCut));
                });
                obj.ddlLang.val(me.settings.userLangIDForCulture);
                //obj.ddlLang.append(ddl);
                obj.clear = me._setObj("", "").css("clear", "both");
                obj.header.append(obj.logo, obj.title, obj.ddlLang, obj.clear);

               
            }
            obj.wrapper.append(obj.header);
            me.divEntry.append(obj.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    
    _buildTopMenu: function (me) {
        /// <summary>
        /// This function builds the top menu html structure only
        /// </summary>
        try {



            //add the top menu
            let obj = me.myHtml.topMenu;
            obj.wrapper = me._setObj("div-top-menu", "");
                       
            obj.box1 = me._setObj("", "box col1 vc-grid-margin-right");

            obj.btnBack = me._setObj("div-btn-back", "float-box  vc-grid-margin-right noprint ").html(me.specific.resources.close);

            obj.id = me._setObj("div-id", "float-box  vc-grid-margin-right");
            obj.orderNo = me._setObj("div-order-no", "float-box print-header vc-grid-margin-right").hide()
            obj.btnPrint = me._setObj("div-btn-print", "float-box  btn color-font-secondary noprint vc-grid-margin-right").html("<i class='fa fa-print' ></i>").attr("title", me.specific.resources.print);
            obj.btnDelete = me._setObj("div-btn-delete", "float-box  btn icon-color-error noprint ").html("<i class='fa fa-times' ></i>").attr("title", me.specific.resources.delete);

            obj.box1.append(obj.btnBack, obj.id, obj.orderNo, obj.btnPrint, obj.btnDelete);
            obj.wrapper.append(obj.box1);

            //save button and error infos
            obj.box2 = me._setObj("", "box col2 noprint");
            obj.state = me._setObj("div-state", "vc-grid-3col clear");

            // button container (2 buttons aligned next to each other)
            obj.btnBox = me._setObj("", "state-buttons");

            // Save (NO close, NO email dialog)
            obj.btnSave = me._setObj("div-btn-save", "btn").html(me.specific.resources.save);

            // Save & Close (current behavior)
            obj.btnSaveClose = me._setObj("div-btn-save-close", "btn").html(me.specific.resources.save + " & " + me.specific.resources.close);

            obj.btnBox.append(obj.btnSave, obj.btnSaveClose);

            // infos
            obj.errors = me._setObj("div-errors", "state-info noprint");
            obj.errorTotal = me._setObj("span-error-total", "state-info");
            obj.errors.append(obj.errorTotal, me.specific.resources.error);

            obj.saved = me._setObj("div-saved", "state-info noprint").html(me.specific.resources.changesSaved);

            // order: buttons | errors | saved
            obj.state.append(obj.btnBox, obj.errors, obj.saved);

            obj.box2.append(obj.state);

            obj.subMenu = me._setObj("div-sub-menu", "vc-grid-margin-top float-box  vc-grid-4col noprint");
            obj.btnMain = me._setObj("", "div-sub-menu button-toggle button-toggle-active").data("type", 1).html(me.specific.resources.overview);
            obj.btnAccounting = me._setObj("", "div-sub-menu button-toggle").data("type", 2).html(me.specific.resources.accounting);
            obj.btnActivities = me._setObj("", "div-sub-menu button-toggle").data("type", 3).html(me.specific.resources.activities);
            //obj.btnWatchlist = me._setObj("", "div-sub-menu button-toggle").data("type", 4).html("int. " + me.specific.resources.observer);
            obj.btnExtWatchlist = me._setObj("", "div-sub-menu button-toggle").data("type", 5).html(me.specific.resources.recipients);
            obj.btnEmailHistory = me._setObj("", "div-sub-menu button-toggle").data("type", 6).html(me.specific.resources.emailHistory);
            obj.btnProjectInfo = me._setObj("", "div-sub-menu button-toggle").data("type", 7).html(me.specific.resources.project + " - " + me.specific.resources.info);
            obj.subMenu.append(obj.btnMain, obj.btnAccounting, obj.btnActivities,  obj.btnExtWatchlist, obj.btnEmailHistory, obj.btnProjectInfo);

            
            obj.wrapper.append(obj.box2, $("<div>").css("clear", "both"), obj.subMenu);
          
            me.divEntry.append(obj.wrapper);



        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildPrintInfoRow: function (me) {
        try {
            let obj = me.myHtml.rowPrintInfo;

            // info box which is only visible in printing mode + activities only
            obj.boxPrintInfo = me._setObj("div-box-print-info", "formFieldset no-simple-edit box col2 vc-grid-margin-bottom").css("width", "100%").css("height", "auto").hide();
            obj.boxPrintRow1 = me._setObj("", "box col2").css("width", "100%").css("height", "auto");
            obj.boxPrintRow2 = me._setObj("", "box col2").css("width", "100%").css("height", "auto");

            //first row of print info
            obj.divProject = me._setObj("div-project", "formItem float-box formItemValid type-select has-tip vc-grid-2col vc-grid-margin-right").attr("title", me.specific.resources.tipTicketOwner);
            obj.captionProject = me._setObj("", "caption").html(me.specific.resources.project);
            obj.txtProject = me._setObj("txt-project", "value large readonly");
            obj.divProject.append(obj.captionProject, obj.txtProject);
            obj.boxPrintRow1.append(obj.divProject);

            obj.divBillingContact = me._setObj("div-billing-contact", "formItem float-box formItemValid type-select has-tip vc-grid-5col vc-grid-margin-right").attr("title", me.specific.resources.tipTicketOwner);
            obj.captionBillingContact = me._setObj("", "caption").html(me.specific.resources.invoiceRecipient);
            obj.txtBillingContact = me._setObj("txt-billing-contact", "value large readonly");
            obj.divBillingContact.append(obj.captionBillingContact, obj.txtBillingContact);
            obj.boxPrintRow1.append(obj.divBillingContact);


            // second row of print info
            obj.divTicketId = me._setObj("div-ticket-id", "formItem float-box formItemValid type-select has-tip vc-grid-2col vc-grid-margin-right").attr("title", me.specific.resources.tipTicketOwner);
            obj.captionTicketId = me._setObj("", "caption").html(me.specific.resources.ticket);
            obj.txtTicketId = me._setObj("txt-ticket-id", "value large readonly");
            obj.divTicketId.append(obj.captionTicketId, obj.txtTicketId);
            obj.boxPrintRow2.append(obj.divTicketId);

            obj.divTicketName = me._setObj("div-ticket-name", "formItem float-box formItemValid type-select has-tip vc-grid-5col vc-grid-margin-right").attr("title", me.specific.resources.tipTicketOwner);
            obj.captionTicketName = me._setObj("", "caption").html(me.specific.resources.name);
            obj.txtTicketName = me._setObj("txt-ticket-name", "value large readonly");
            obj.divTicketName.append(obj.captionTicketName, obj.txtTicketName);
            obj.boxPrintRow2.append(obj.divTicketName);

            obj.boxPrintInfo.append(obj.boxPrintRow1, obj.boxPrintRow2);

            me.divEntry.append(obj.boxPrintInfo);

        } catch (e) { me._writeErr(e); return false; }
    },



    _buildUserRow: function (me) {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        try {


            let rowUser = me.myHtml.rowUser;

            rowUser.wrapper = me._setObj("", "vc-grid-margin-bottom").css("height", "auto");
            rowUser.userBox = {};


            //add the user box
            let obj = me.myHtml.rowUser.userBox;
            obj.wrapper = me._setObj("div-user", "formFieldset no-simple-edit box col2 vc-grid-margin-bottom").css("width", "100%");


            obj.divOwner = me._setObj("div-ddl-owner", "dropdown formItem float-box formItemValid type-select has-tip vc-grid-2col vc-grid-margin-right").attr("title", me.specific.resources.tipTicketOwner);
            obj.captionOwner = me._setObj("", "caption").html(me.specific.resources.owner);
            obj.ddlOwner = me._setObj("ddl-owner", "value edit ddl").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtOwner = me._setObj("txt-owner", "value large readonly is-ddl");
            obj.divOwner.append(obj.captionOwner, obj.ddlOwner, obj.txtOwner);
            obj.wrapper.append(obj.divOwner);



            obj.divExecutor = me._setObj("div-ddl-executor", "dropdown formItem float-box  formItemValid type-select has-tip vc-grid-2col").css("border-right", "0px hidden").css("padding-bottom", "0.35em");
            obj.captionExecutor = me._setObj("", "caption").html(me.specific.resources.executor);
            obj.ddlExecutor = me._setObj("ddl-executor", "value edit ddl").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtExecutor = me._setObj("txt-executor", "value large readonly is-ddl");
            obj.divExecutor.append(obj.captionExecutor, obj.ddlExecutor, obj.txtExecutor);

            obj.divDateExecutionBox = me._setObj("div-date-execution", "formItem float-box  formItemValid type-date dates  vc-grid-margin-right").css("border-left", "0px hidden");
            obj.dateExecution = {};
            obj.dateExecution.clear = me._setObj("clear-date", "clear-date").data("date", "vc-date-execution").html("<i  class='fa fa-times'></i>");
            obj.dateExecution.caption = me._setObj("", "caption").html(me.specific.resources.completion);
            obj.dateExecution.caption.append(obj.dateExecution.clear);
            obj.dateExecution.divDate = me._setObj("vc-date-execution", "value edit");
            obj.dateExecution.txtDate = me._setInput("txt-date-execution", "value large readonly");
            obj.divDateExecutionBox.append(obj.dateExecution.caption, obj.dateExecution.divDate, obj.dateExecution.txtDate);
            obj.wrapper.append(obj.divExecutor);



            
            obj.wrapper.append(obj.divDateExecutionBox);

            obj.divValidator = me._setObj("div-ddl-validator", "dropdown formItem float-box  formItemValid type-select has-tip vc-grid-2col").css("border-right", "0px hidden").css("padding-bottom", "0.35em");
            obj.captionValidator = me._setObj("", "caption").html(me.specific.resources.validation);
            obj.ddlValidator = me._setObj("ddl-validator", "value edit ddl").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtValidator = me._setObj("txt-validator", "value large readonly  is-ddl");
            obj.divValidator.append(obj.captionValidator, obj.ddlValidator, obj.txtValidator);
            obj.wrapper.append(obj.divValidator);


            obj.divDateValidationBox = me._setObj("div-date-validation", "formItem float-box  formItemValid type-date dates").css("border-left", "0px hidden");
            obj.dateValidation = {};
            obj.dateValidation.clear = me._setObj("clear-date", "clear-date").data("date", "vc-date-validation").html("<i  class='fa fa-times'></i>");
            obj.dateValidation.caption = me._setObj("", "caption").html(me.specific.resources.completion);
            obj.dateValidation.caption.append(obj.dateValidation.clear);
            obj.dateValidation.divDate = me._setObj("vc-date-validation", "value edit");
            obj.dateValidation.txtDate = me._setInput("txt-date-validation", "value large readonly");
            obj.divDateValidationBox.append(obj.dateValidation.caption, obj.dateValidation.divDate, obj.dateValidation.txtDate);
            obj.wrapper.append(obj.divDateValidationBox);

            rowUser.wrapper.append(obj.wrapper, $("<div>").css("clear", "both"));
            me.divEntry.append(rowUser.wrapper);



        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildMainRow: function (me) {
        /// <summary>
        /// This function builds the main html structure with info box and assignment box
        /// </summary>
        try {

            let rowMain = me.myHtml.rowMain;

            rowMain.wrapper = me._setObj("row-main", "");
            rowMain.infoBox = {};


            //add the info box
            let obj = me.myHtml.rowMain.infoBox;
            obj.wrapper = me._setObj("div-col-info", "formFieldset box col1 vc-grid-margin-right");

            //add left options
            obj.options = me._setObj("", "coll  float-box ");

            //add tasks dropdown
            obj.divTasks = me._setWrapper("div-ddl-task", "formItem no-simple-edit  formItemValid type-select vc-grid-1col vc-grid-margin-right vc-grid-margin-bottom ");
            obj.captionTasks = me._setObj("", "caption").html(me.specific.resources.type);
            obj.ddlTasks = me._setObj("ddl-task", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtTasks = me._setObj("txt-task", "value large readonly is-ddl");
            obj.divTasks.append(obj.captionTasks, obj.ddlTasks, obj.txtTasks);
            obj.options.append(obj.divTasks);
            //add priority dropdown
            obj.divPriority = me._setWrapper("div-ddl-priority", "formItem  no-simple-edit formItemValid type-select vc-grid-1col vc-grid-margin-right vc-grid-margin-bottom ");
            obj.captionPriority = me._setObj("", "caption").html(me.specific.resources.priority);
            obj.ddlPriority = me._setObj("ddl-priority", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtPriority = me._setObj("txt-priority", "value large readonly is-ddl");
            obj.divPriority.append(obj.captionPriority, obj.ddlPriority, obj.txtPriority);
            obj.options.append(obj.divPriority);

            //add scope dropdown
            obj.divScope = me._setWrapper("div-ddl-scope", "formItem no-simple-edit formItemValid type-select vc-grid-1col vc-grid-margin-right");
            obj.captionScope = me._setObj("", "caption").html(me.specific.resources.scope);
            obj.ddlScope = me._setObj("ddl-scope", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtScope = me._setObj("txt-scope", "value large readonly is-ddl");
            obj.divScope.append(obj.captionScope, obj.ddlScope, obj.txtScope);
            obj.options.append(obj.divScope);

            obj.wrapper.append(obj.options);

            //add main field
            obj.main = me._setObj("", "col vc-grid-3col");
            obj.captionName = me._setObj("", "caption").html(me.specific.resources.name);
            obj.divName = me._setObj("div-txt-name", "formItem float-box  formItemValid type-text vc-grid-3col");
            obj.txtName = me._setInput("txt-name", "value large");
            obj.divName.append(obj.captionName, obj.txtName);
            obj.main.append(obj.divName);

            obj.divDateStartBox = me._setObj("div-date-start", "formItem float-box  formItemValid type-date dates  vc-grid-margin-bottom").css("border-right", "0px hidden").css("padding-bottom", "0.35em");
            obj.captionDateStart = me._setObj("", "caption").html(me.specific.resources.start);
            obj.divDateStart = me._setObj("vc-date-start", "value edit");
            obj.txtDateStart = me._setInput("txt-date-start", "value large readonly");
            obj.divDateStartBox.append(obj.captionDateStart, obj.divDateStart, obj.txtDateStart);
            obj.main.append(obj.divDateStartBox);

            obj.divDateCompletionBox = me._setObj("div-date-completition", "formItem  float-box  formItemValid  type-date dates has-tip").attr("title", me.specific.resources.tipTicketCompletitionDate).css("border-left", "0px hidden");
            obj.dateCompletion = {};

            obj.dateCompletion.caption = me._setObj("", "caption").html(me.specific.resources.planedCompletion);
            obj.dateCompletion.clear = me._setObj("clear-date", "clear-date").data("date", "vc-date-completition").html("<i  class='fa fa-times'></i>");
            obj.dateCompletion.caption.append(obj.dateCompletion.clear);
            obj.dateCompletion.divDate = me._setObj("vc-date-completition", "value edit");
            obj.dateCompletion.txtDate = me._setInput("txt-date-completition", "value large readonly");
            obj.divDateCompletionBox.append(obj.dateCompletion.caption, obj.dateCompletion.divDate, obj.dateCompletion.txtDate);
            obj.main.append(obj.divDateCompletionBox);


            obj.divState = me._setObj("div-ddl-state", "formItem no-simple-edit formItemValid type-select");
            obj.captionState = me._setObj("", "caption").html(me.specific.resources.state);
            obj.ddlState = me._setObj("ddl-state", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtState = me._setObj("txt-state", "value large readonly is-ddl");
            obj.divState.append(obj.captionState, obj.ddlState, obj.txtState);
            obj.main.append(obj.divState);
            obj.wrapper.append(obj.main);


            obj.divEditor = me._setObj("div-editor", "formItem formItemValid type-text");
            obj.captionDescription = me._setObj("", "caption").html(me.specific.resources.description);
            obj.divDescription = me._setObj("div-description", "value readonly");
            obj.txtDescription = me._setTextArea("area-description", "value");
            obj.divEditor.append(obj.captionDescription, obj.divDescription, obj.txtDescription);

            obj.wrapper.append(obj.divEditor);
            rowMain.wrapper.append(obj.wrapper);


           
            //add the assignment box
            rowMain.assignmentBox = {};
            obj = me.myHtml.rowMain.assignmentBox;
            obj.wrapper = me._setWrapper("div-assignments", "formFieldset formItem box col2 vc-grid-3col-menu");

            obj.divEdit = me._setWrapper("div-edit", "");
            obj.btnAssProject = me._setObj("", "div-assign-type button-toggle button-toggle-active").data("type", me.specific.ASSIGNMENT_PROJECT_TYPEID).html(me.specific.resources.project);
            obj.btnAssUnit = me._setObj("", "div-assign-type button-toggle").data("type", me.specific.ASSIGNMENT_UNIT_TYPEID).html(me.specific.resources.unit);
            obj.btnAssSignals = me._setObj("", "div-assign-type button-toggle").data("type", me.specific.ASSIGNMENT_SIGNAL_TYPEID).html(me.specific.resources.signals);
            obj.divEdit.append(obj.btnAssProject, obj.btnAssUnit, obj.btnAssSignals);
            obj.wrapper.append(obj.divEdit);

            obj.divLogger = me._setWrapper("div-ddl-logger", "formItem formItemValid type-select vc-grid-3col vc-grid-margin-bottom");
            obj.captionLogger = me._setObj("", "caption").html(me.specific.resources.project);
            obj.ddlLogger = me._setObj("ddl-logger", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtLogger = me._setObj("txt-logger", "value large readonly");
            obj.divLogger.append(obj.captionLogger, obj.ddlLogger, obj.txtLogger);
            obj.wrapper.append(obj.divLogger);

            obj.divUnit = me._setWrapper("div-ddl-unit", "formItem formItemValid type-select vc-grid-3col");
            obj.captionUnit = me._setObj("", "caption").html(me.specific.resources.unit);
            obj.ddlUnit = me._setObj("ddl-unit", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtUnit = me._setObj("txt-unit", "value large readonly");
            obj.divUnit.append(obj.captionUnit, obj.ddlUnit, obj.txtUnit);
            obj.wrapper.append(obj.divUnit);

            obj.divHW = me._setWrapper("div-ddl-hw", "formItem formItemValid type-select vc-grid-3col");
            obj.captionHW = me._setObj("", "caption").html(me.specific.resources.hardware);
            obj.ddlHW = me._setObj("ddl-hw", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtHW = me._setObj("txt-hw", "value large readonly");
            obj.divHW.append(obj.captionHW, obj.ddlHW, obj.txtHW);
            obj.wrapper.append(obj.divHW);

            obj.divSignals = me._setWrapper("", "formItem");
            obj.captionSignals = me._setObj("div-signals-caption", "caption").html(me.specific.resources.signals);
            obj.divSignalFilter = me._setObj("div-signals-filter", "vc-grid-2col");
            obj.signalList = me._setObj("div-signals", "sublist vc-list");
            obj.divSignals.append(obj.captionSignals, obj.divSignalFilter, obj.signalList);
            obj.wrapper.append(obj.divSignals);

            rowMain.wrapper.append(obj.wrapper);
            me.divEntry.append(rowMain.wrapper);




        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildAccountingRow: function (me) {
        /// <summary>
        /// This function builds the accounting html structure
        /// </summary>
        try {

            let obj = me.myHtml.rowAccounting;
            obj.wrapper = me._setObj("row-accounting", "formFieldset no-simple-edit box col2 vc-grid-margin-bottom").css("width", "100%").html("");

            obj.wrapper.hide();
            obj.billing = me._setObj("", "coll float-box vc-grid-2col vc-grid-margin-right");

            obj.captionOrder = me._setObj("", "caption").html(me.specific.resources.order);
            obj.divOrder = me._setObj("div-txt-order", "formItem float-box  formItemValid type-text vc-grid-2col vc-grid-margin-bottom");
            obj.txtOrder = me._setInput("txt-order", "value large").css("width", "92%");
            obj.divOrder.append(obj.captionOrder, obj.txtOrder);

            //add order type dropdown
            obj.divOrderType = me._setObj("div-ddl-ordertype", "formItem  formItemValid type-select vc-grid-2col vc-grid-margin-bottom ").css("width", "96%");
            obj.captionOrderType = me._setObj("", "caption").html(me.specific.resources.orderType);
            obj.ddlOrderType = me._setObj("ddl-ordertype", "value edit").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtOrderType = me._setObj("txt-ordertype", "value large readonly is-ddl");
            obj.divOrderType.append(obj.captionOrderType, obj.ddlOrderType, obj.txtOrderType);

            obj.billing.append(obj.divOrder, obj.divOrderType);

            obj.wrapper.append(obj.billing);


            obj.accounting = me._setObj("", "coll float-box vc-grid-2col vc-grid-margin-right");

            obj.divAccounter = me._setObj("div-ddl-Accounter", "dropdown formItem float-box  formItemValid type-select has-tip vc-grid-2col").css("border-right", "0px hidden").css("padding-bottom", "0.35em");
            obj.captionAccounter = me._setObj("", "caption").html(me.specific.resources.accounting);
            obj.ddlAccounter = me._setObj("ddl-Accounter", "value edit ddl").attr("placeholder", me.specific.resources.pleaseSelect);
            obj.txtAccounter = me._setObj("txt-vAccounter", "value large readonly  is-ddl");
            obj.divAccounter.append(obj.captionAccounter, obj.ddlAccounter, obj.txtAccounter);
            obj.accounting.append(obj.divAccounter);


            obj.divDateAccountingBox = me._setObj("div-date-accounting", "formItem float-box  formItemValid type-date dates").css("border-left", "0px hidden");
            obj.dateAccounting = {};
            obj.dateAccounting.clear = me._setObj("clear-date", "clear-date").data("date", "vc-date-accounting").html("<i  class='fa fa-times'></i>");
            obj.dateAccounting.caption = me._setObj("", "caption").html(me.specific.resources.completion);
            obj.dateAccounting.caption.append(obj.dateAccounting.clear);
            obj.dateAccounting.divDate = me._setObj("vc-date-accounting", "value edit");
            obj.dateAccounting.txtDate = me._setInput("txt-date-accounting", "value large readonly");
            obj.divDateAccountingBox.append(obj.dateAccounting.caption, obj.dateAccounting.divDate, obj.dateAccounting.txtDate);
            obj.accounting.append(obj.divDateAccountingBox);
            obj.wrapper.append(obj.accounting);


            obj.docu = me._setObj("", "coll float-box vc-grid-2col ");

            obj.divDocu = me._setWrapper("div-docu", "formItem float formItemValid type-check vc-grid-2col");
            obj.captionDocu = me._setObj("", "caption").html(me.specific.resources.documentation);
            obj.divActivityItem = me._setObj("", "formItemBox");
            obj.chkActivities = me._setInput("chb-docu-activity", "value ").attr("type", "checkbox");
            obj.divActivityItem.append(obj.chkActivities, " " + me.specific.resources.activities);
            obj.divDeliveryNoteItem = me._setObj("", "formItemBox");
            obj.chkDeliveryNote = me._setInput("chb-docu-delivery-note", "value").attr("type", "checkbox");
            obj.divDeliveryNoteItem.append(obj.chkDeliveryNote, " " + me.specific.resources.deliveryNote);
            obj.divWorkReportItem = me._setObj("", "formItemBox vc-grid-margin-bottom");
            obj.chkWorkReport = me._setInput("chb-docu-work-report", "value").attr("type", "checkbox");
            obj.divWorkReportItem.append(obj.chkWorkReport, " " + me.specific.resources.workReport);

            obj.divDocu.append(obj.captionDocu, obj.divActivityItem, obj.divDeliveryNoteItem, obj.divWorkReportItem);
            obj.wrapper.append(obj.docu.append(obj.divDocu));

            me.divEntry.append(obj.wrapper);






        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildActivitiesRow: function (me) {
        /// <summary>
        /// This function builds the activities html structure
        /// </summary>
        try {
          
            let obj = me.myHtml.rowActivities;
            obj.wrapper = me._setObj("divActivities" + me.vcgid, "ticket-activities formFieldset box col2 vc-grid-margin-bottom").css("height", "auto").css("width", "100%").html("");
            obj.wrapper.hide();
            me.divEntry.append(obj.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildWatchlistRow: function (me, obj, cssPart, caption) {
        /// <summary>
        /// This function builds the watchlist html structure
        /// </summary>
        try {

           
            obj.wrapper = me._setObj("row-" + cssPart + "watchlist", "formFieldset box col2 vc-grid-margin-bottom").css("width", "100%");
            obj.divWatchlistList = me._setWrapper("", "formItem");
            obj.captionWatchlist = me._setObj("", "caption").html(caption);
            obj.divWatchlist = me._setObj("div-" + cssPart + "watchlist", "sublist vc-list");
            obj.divWatchlistList.append(obj.captionWatchlist, obj.divWatchlist);
            obj.wrapper.append(obj.divWatchlistList);
            obj.wrapper.hide();

            me.divEntry.append(obj.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _buildEmailHistoryRow: function (me) {
        /// <summary>
        /// This function builds the email history list
        /// </summary>
        try {

            let obj = me.myHtml.rowEmailHistory;
            obj.wrapper = me._setObj("row-email-history", "formFieldset box col2 vc-grid-margin-bottom").css("width", "100%");
            obj.divEmailList = me._setObj("div-email-history-list", "vc-list").css("overflow-y", "auto");
            obj.wrapper.append(obj.divEmailList);
            obj.wrapper.hide();
            me.divEntry.append(obj.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildProjectInfoRow: function (me) {
        /// <summary>
        /// This function builds the project info html structure
        /// </summary>
        try {

            let obj = me.myHtml.rowProjectInfo;

            obj.wrapper = me._setObj("div-project-info-row", "formFieldset no-simple-edit box col2 vc-grid-margin-bottom").css("width", "100%").hide();
            obj.captionDescription = me._setObj("", "caption").html(me.specific.resources.description);
            obj.divDescription = me._setObj("div-project-description", "formItem float-box formItemValid readonly type-text vc-grid-3col vc-grid-margin-bottom");           
            obj.txtDescription = me._setObj("txt-project-description", "value large").css("width", "92%");

            obj.divDescription.append(obj.captionDescription, obj.txtDescription);

            obj.wrapper.append(obj.divDescription);

            me.divEntry.append(obj.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _buildFooter: function (me) {
        /// <summary>
        /// This function builds the footer html structure
        /// </summary>
        try {
            let obj = me.myHtml.footer;
            obj.wrapper = me._setObj("div-id-infos", "").css("width", "100%");
            obj.lastEdited = me._setObj("div-last-edited", "");
            obj.wrapper.append(obj.lastEdited);
            me.divEntry.append(obj.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

};